export const INTEGRATION_TYPES = {
  INTERCOM: 'Intercom Integration',
  RUDDERSTACK: 'Rudderstack Integration',
  ZOHO_DESK: 'Zoho Desk Integration',
  STRIPE_CUSTOMER_PORTAL: 'Stripe - Customer Portal',
  DYNAMIC_LINKS: 'Dynamic Links Integration',
  DOLLAR_DAD_CLUB_WIDGET: 'dollar_dad_club_widget',
  MESSAGE_CENTER_OVERRIDE: 'message_center_override'
};

export const INTEGRGATION_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive'
};
